import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class GlobalStoreService {
	logoFileToStore$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	updateListFiles$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	filesToUpload$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	filesToCompany$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	filesToOption$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	coverFileToStore$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	logoFileToTerminal$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	coverFileToTerminal$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	filesToTerminalPlaylist$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	editingPointOfSales$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	editingPointOfSalesCategory$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	editingCompany$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	editingAdherents$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	redeemVoucher$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	editingStore$: BehaviorSubject<any> = new BehaviorSubject<null>(null);
	editingRole$: BehaviorSubject<any> = new BehaviorSubject<null>(null);
	editingPwa$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

	editingLogoTerminal$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	editingCoverTerminal$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
}
